/**
 * Dashboard öne çıkan olay — highlights listesinden tek aday seçimi (salt istemci).
 */

import { rarityKey } from './collectionUi';

/** Aday olay puanı; uygun değilse -1 */
export function featuredEventScore(ev) {
  if (!ev || !ev.event_type) return -1;
  const rk = rarityKey(ev.asset_rarity);
  const sl = Number(ev.star_level) || 0;
  const ms = Number(ev.collection_score) || 0;

  switch (ev.event_type) {
    case 'rare_drop':
      if (rk === 'mythic') return 100;
      if (rk === 'legendary') return 90;
      if (rk === 'epic') return 80;
      return -1;
    case 'star_progress':
      if (sl >= 3) return 70;
      if (sl === 2) return 60;
      return -1;
    case 'collection_score_milestone':
      if (ms >= 2500) return 65;
      if (ms >= 1000) return 60;
      if (ms >= 500) return 50;
      return -1;
    default:
      return -1;
  }
}

/**
 * Highlights dizisinden en güçlü tekil olay (skor, eşitlikte daha yeni).
 */
export function pickFeaturedHighlightEvent(events) {
  if (!Array.isArray(events) || events.length === 0) return null;
  const scored = events
    .map((ev) => ({ ev, score: featuredEventScore(ev) }))
    .filter((x) => x.score >= 0);
  if (scored.length === 0) return null;
  scored.sort((a, b) => {
    if (b.score !== a.score) return b.score - a.score;
    const ta = a.ev.created_at || '';
    const tb = b.ev.created_at || '';
    return tb.localeCompare(ta);
  });
  return scored[0].ev;
}

function safeName(s, fallback = '—') {
  const t = typeof s === 'string' ? s.trim() : '';
  return t || fallback;
}

/** Kart üst etiketi (kısa başlık) */
export function featuredHighlightHeading(ev) {
  if (!ev) return '';
  const rk = rarityKey(ev.asset_rarity);
  switch (ev.event_type) {
    case 'rare_drop':
      if (rk === 'mythic') return 'Mitik keşif';
      if (rk === 'legendary') return 'Efsanevi keşif';
      if (rk === 'epic') return 'Epik keşif';
      return 'Nadir keşif';
    case 'star_progress':
      return 'Yıldız yükselişi';
    case 'collection_score_milestone':
      return 'Koleksiyon başarısı';
    default:
      return 'Topluluktan';
  }
}

/** Ana açıklama metni (kısa, premium) */
export function featuredHighlightSubline(ev) {
  if (!ev) return '';
  const u = safeName(ev.user_display_name, 'Bir koleksiyoncu');
  const asset = safeName(ev.asset_name, 'parça');
  switch (ev.event_type) {
    case 'rare_drop':
      return `${u}, ${asset} adlı nadir parçayı koleksiyonuna ekledi.`;
    case 'star_progress': {
      const stars = Number(ev.star_level) || 0;
      return `${u}, ${asset} karakterini ${stars}★ seviyesine çıkardı.`;
    }
    case 'collection_score_milestone': {
      const m = Number(ev.collection_score) || 0;
      return `${u}, koleksiyon skorunda ${m.toLocaleString('tr-TR')} eşiğine ulaştı.`;
    }
    default:
      return `${u} koleksiyonunda yeni bir gelişme kaydetti.`;
  }
}

/** Nadirlik rozeti gösterilsin mi (milestone hariç anlamlı) */
export function featuredShowRarityBadge(ev) {
  if (!ev) return false;
  if (ev.event_type === 'collection_score_milestone') return false;
  return Boolean(ev.asset_rarity && String(ev.asset_rarity).trim());
}
